import { render, staticRenderFns } from "./AdvancedSettings.vue?vue&type=template&id=5fa07980&scoped=true&"
import script from "./AdvancedSettings.vue?vue&type=script&lang=js&"
export * from "./AdvancedSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedSettings.vue?vue&type=style&index=0&id=5fa07980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa07980",
  null
  
)

export default component.exports